import { useViewedEvent } from './use-viewed-event';
import { ProjectWithRole } from '@neptune/shared/core-project-domain';

type UseModelDetailsAreViewedAnalyticsEventParams = {
  username: string;
  project: ProjectWithRole | undefined;
  enabled?: boolean;
  modelId: string | undefined;
};

export const useModelDetailsAreViewedAnalyticsEvent = ({
  username,
  project,
  enabled,
  modelId,
}: UseModelDetailsAreViewedAnalyticsEventParams) => {
  useViewedEvent({
    eventName: 'model_details_are_viewed',
    senderUsername: username,
    attributes: {
      projectName: project?.name,
      projectRole: project?.userRoleInProject,
      organizationName: project?.organizationName,
    },
    enabled,
    deps: [modelId],
  });
};
